import {
  Action,
  combineReducers,
  Reducer,
} from 'redux';
import reduceReducers from 'reduce-reducers';

import { hydrateReducer } from '@/core/store/reducers/hydrate';
import { RootState } from '@/core/interfaces/store';

import { configReducer } from '@/features/Config/store';

const featuresReducer = combineReducers({
  config: configReducer,
});

export const rootReducer = reduceReducers<RootState>(
  hydrateReducer,
  featuresReducer
) as Reducer<RootState, Action>;

